const CategoryChips = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_titleSettings: {
        order: 1,
        type: 'Menu',
        renderOptions: {
          controlKey: 'titleSettings',
        },
        options: {
          textSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          textColor: {
            type: 'HexColor',
          },
          textStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          textWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          textWordSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
          textLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 6,
          },
        },
      },
      Menu_GeneralSettings: {
        order: 1,
        type: 'Menu',
        renderOptions: {
          controlKey: 'generalSettings',
        },
        options: {
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 8,
            options: {
              containerPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              padding: {
                data: {
                  max: 20,
                  min: 0,
                  step: 2,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              borderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          'widget.ToggleRadioTabs_1': {
            type: 'ToggleRadioTabs',
            order: 9,
            renderOptions: {
              direction: 'row',
              controlKey: 'backgroundType',
            },
            options: {
              backgroundImage: {
                type: 'ImageUploader',
              },
              backgroundColor: {
                type: 'HexColor',
              },
            },
          },
          backgroundSize: {
            type: 'Radio',
            order: 10,
            data: {
              direction: 'row',
              radioOptions: ['cover', 'contain', 'stretch'],
            },
          },
          boxShadow: {
            type: 'ChildComponentRenderer',
            order: 11,
            data: {
              componentNames: ['shadow1', 'shadow2', 'shadow3'],
            },
          },
        },
      },
      ToggleTabs_1: {
        type: 'ToggleTabs',
        order: 5,
        renderOptions: {
          controlKey: 'isIcon',
        },
        options: {},
      },
    },
  },
  variants: [
    {
      id: 'CategoryChips_1',
      name: 'CategoryChips_1',
      type: 'CategoryChips',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '8px',
        textColor: '#000000',
        borderColor: '#E4E7EB',
        innerBackgroundColor: '#F8F8F8',
        containerPadding: '10px 10px 10px 10px',
        borderRadius: '10px 10px 10px 10px',
        backgroundColor: '#FFFFFF',
        backgroundImage: '',
        backgroundType: '-',
        textWeight: '400',
        padding: '3px 15px 3px 15px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 10,
        modulo: 1,
        canUpdatedWithoutImage: true,
        isForcedInternalLinking: true,
        imageDisabled: true,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_7.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CategoryChips_2',
      name: 'CategoryChips_2',
      type: 'CategoryChips',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '8px',
        textColor: '#000000',
        borderColor: '#E4E7EB',
        innerBackgroundColor: '#F8F8F8',
        containerPadding: '10px 10px 10px 10px',
        borderRadius: '10px 10px 10px 10px',
        backgroundColor: '#FFFFFF',
        backgroundImage: '',
        backgroundType: '-',
        textWeight: '400',
        padding: '3px 15px 3px 15px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 10,
        modulo: 1,
        canUpdatedWithoutImage: true,
        isForcedInternalLinking: true,
        imageDisabled: true,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_7.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default CategoryChips;
